import { Component, ElementRef, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'sp-dropdown',
  standalone: false,
  templateUrl: './sp-dropdown.component.html',
  styleUrls: ['./sp-dropdown.component.scss']

})
export class SpDropdownComponent {
  clickHandler: any;

  constructor(private _eref: ElementRef, private renderer: Renderer2) {}
  @Input() links: Array<DropdownMenuLink>;
  @Input() icon: string;
  @Input() dropDownId: string;
  @Input() align: string;
  @Input() forHeader: boolean;
  @Input() color: string = '';
  @Input() isContextMenu: boolean = false;
  openItem = false;
  openDropdown() {
    this.openItem = !this.openItem;
    this.renderer.addClass(document.body, 'no-scoll-class');
    if (this.openItem) {
      this.clickHandler = this.clickFunction.bind(this);
      window.addEventListener('click', this.clickHandler, true);
    }
  }

  clickFunction() {
    window.removeEventListener('click', this.clickHandler, true);
    this.closeDropdown();
  }
  closeDropdown() {
    this.openItem = false;
    this.renderer.removeClass(document.body, 'no-scoll-class');
  }
}

export interface DropdownMenuLink {
  label: string;
  url?: string;
  queryParams?: Record<string, unknown>;
  action?: any;
  dropDown?: string;
}